// removed by extract-text-webpack-plugin
module.exports = {"h2style":"h2style__2eT9N","Faq-wrapper":"Faq-wrapper__2V7_-"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/components/FAQ/Faq.scss
// module id = 731
// module chunks = 68